// import promiseRetry from 'promise-retry';
import React, { useEffect, useRef, useState } from 'react';

type CADElement = HTMLDivElement | null;
type CADElementRef = React.MutableRefObject<CADElement>;

/**
 * Attaches CAD when SDK and design are ready and then returns `true` once attached
 */
export function useAttachCAD(sdk: any, design: any): {
  attached: boolean;
  cadElementRef: CADElementRef;
} {
  const cadElementRef = useRef<CADElement>(null);
  const [attached, setAttached] = useState<boolean>(false);
  useEffect(() => {
    if (!sdk || !design) {
      console.warn('Cannot attach CAD -- no SDK/no design loaded.')
      return;
    }

    const element = cadElementRef.current;
    if (!element) {
      console.warn('Cannot attach CAD -- invalid ref.')
      return;
    }

    sdk?.cad?.attach(element)
      .then(() => {
        console.log('Successfully attached CAD');
        setAttached(true);
      })
      .catch((err: any) => {
        console.error(err);
      });
  }, [ sdk, design ]);
  
  return { attached, cadElementRef };
}